document.querySelectorAll('[data-pl-car]').forEach(function (car) {
  var row = car.querySelector('.pl-grid--scroll');
  car.querySelectorAll('.pl-car__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dir = btn.classList.contains('pl-car__btn--next') ? 1 : -1;
      row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: 'smooth' });
    });
  });
});
